import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export interface ImageState {
    src: string;
}

const initialState: ImageState = {
    src: '/assets/makeawish.jpg',
};

export const imageSlice = createSlice({
    name: 'chain',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setImageSrc: (state: ImageState, action: PayloadAction<string>) => {
            state.src = action.payload;
        },
    },

});

export const { setImageSrc } = imageSlice.actions;

export const selectImageSrc = (state: RootState) => state.image.src;

export default imageSlice.reducer;
